(function () {
  if (!window.webVitals) return;

  function getAttribution(metric) {
    const attribution = metric && metric.attribution ? metric.attribution : {};
    const eventTarget = attribution.interactionTarget || attribution.largestShiftTarget || attribution.target || '';
    const eventType = attribution.interactionType || '';

    return {
      target: String(eventTarget || '').slice(0, 100),
      eventType: String(eventType || '').slice(0, 40),
    };
  }

  function send(metric) {
    if (!metric || typeof window.gtag !== 'function') return;

    const attribution = getAttribution(metric);
    const value = Number(metric.value || 0);
    window.gtag('event', 'cwv_metric', {
      metric_name: metric.name,
      metric_value: metric.name === 'CLS' ? Number(value.toFixed(4)) : Math.round(value),
      metric_rating: metric.rating || '',
      metric_id: metric.id || '',
      page_path: window.location.pathname,
      attribution_target: attribution.target,
      attribution_event_type: attribution.eventType,
    });
  }

  window.webVitals.onCLS(send);
  window.webVitals.onINP(send);
  window.webVitals.onLCP(send);
})();
